import { UserAvatar } from './user-profile.model';

/** Upload ceiling the API enforces on `photo` (5 MB). */
export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;

/**
 * Image types accepted for the profile picture. SVG is deliberately out: it is
 * XML, and XML carries script.
 */
export const AVATAR_ACCEPTED_MIME_TYPES: ReadonlySet<string> = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
]);

/** Value for the file input's `accept`, kept in step with the set above. */
export const AVATAR_ACCEPT_ATTRIBUTE = [...AVATAR_ACCEPTED_MIME_TYPES].join(',');

/**
 * Why the client gate turned a picked file down before any request is made.
 * The minimum of 64x64 pixels is not gated here — reading it means decoding the
 * image, and the API answers that one with a `422` message ready to display.
 */
export type AvatarRejectionReason = 'type' | 'size';

/** Message shown for each client-side rejection. */
export const AVATAR_REJECTION_MESSAGE_KEY: Readonly<Record<AvatarRejectionReason, string>> = {
  type: 'MY_ACCOUNT.PHOTO_INVALID_TYPE',
  size: 'MY_ACCOUNT.PHOTO_TOO_LARGE',
};

/** Status of the picture upload lifecycle. */
export type AvatarUploadStatus = 'idle' | 'uploading' | 'uploaded' | 'error';

/**
 * Status of the picture removal lifecycle. `DELETE user/avatar` answers `200`
 * even when the account had no picture, so `removed` is the only success there is.
 */
export type AvatarRemovalStatus = 'idle' | 'removing' | 'removed' | 'error';

/** Answer of `POST user/avatar`: the picture the upload stored. */
export interface AvatarUploadResponse {
  readonly avatar: UserAvatar;
}
